<template>

    <div class="container">

        <h3 class="padding teal textAlignCenter">Your Selections</h3>

        <!--<p>{{printJob.printJobSpec.stockType}}</p>-->

        <!--<p class="padding textAlignCenter">Type: {{printJob.printJobSpec.name}} - {{printJob.printJobSpec.name}} | Weight: {{printJob.printJobSpec.stockWeight}} | Lamination: {{printJob.printJobSpec.lamination}} | Quantity: {{printJob.printJobSpec.quantity}} </p>-->

        <p class="padding textAlignCenter">Type: {{printJob.printJobSpec.fCode}} | Weight: {{printJob.printJobSpec.stockWeight}} | Lamination: {{printJob.printJobSpec.lamination}} | Quantity: {{printJob.printJobSpec.quantity}} </p>

    </div>

</template>

<script>

    import Axios from 'axios';
    import Router from '../router';

    export default {
        name: "selections",
        components: {},
        props: {
            printJob: {}
        },
        data() {
            return {
            }
        },
        created() {

        },
        methods: {
            next() {
                // Router.push({
                //     name: 'wizardProducts'
                // });
            }
        }
    };
</script>